export default "__VITE_ASSET__BYEaJHpC__"